<template>
  <v-table>
    <thead>
      <tr>
        <th>{{ t('language.title') }}</th>
        <th v-if="showFluency">
          {{ t('language.fluency') }}
        </th>
        <th>
          {{ t('actions.delete') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(lang, index) in selectedLanguages"
        :key="index"
      >
        <td>
          <model-select-dropdown
            v-model="lang.id"
            class="mt-3"
            :label="t('language.title')"
            index-route="/api/languages"
            label-field-name="descr"
            sort-field-name="name"
            :per-page="300"
            @input="newLanguageSelected"
          />
        </td>
        <td v-if="showFluency">
          <v-select
            v-model="lang.pivot.proficiency"
            :label="t('language.fluency')"
            class="mt-3"
            :items="proficiencyLevels"
          />
        </td>
        <td>
          <v-btn
            color="error"
            class="mt-n4"
            :text="t('actions.delete')"
            @click="deleteItem(index)"
          />
        </td>
      </tr>
      <tr>
        <td>
          <model-select-dropdown
            v-model="newLanguage"
            class="mt-3"
            :label="t('language.add_another')"
            index-route="/api/languages"
            label-field-name="descr"
            sort-field-name="name"
            :per-page="300"
            clear-on-select
            @update:model-value="newLanguageSelected"
          />
        </td>
        <td v-if="showFluency" />
        <td />
      </tr>
    </tbody>
  </v-table>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ModelSelectDropdown from '../crud/ModelSelectDropdown.vue';

withDefaults(defineProps <{
  showFluency?: boolean;
}>(), {
  showFluency: () => false,
});

const { t } = useI18n();

const selectedLanguages = defineModel<App.ApiResources.Language[] | null>();
const newLanguage = ref();

const proficiencyLevels = [
  {
    value: 1,
    title: t('language.fluent'),
  },
  {
    value: 0,
    title: t('language.conversational'),
  },
];

function newLanguageSelected(value: number): void {
  if (selectedLanguages.value && Array.isArray(selectedLanguages.value)) {
    selectedLanguages.value.push({
      id: value,
      pivot: { proficiency: 1 },
    });
  }
  else {
    selectedLanguages.value = [
      {
        id: value,
        pivot: { proficiency: 1 },
      },
    ];
  }
  newLanguage.value = null;
}

function deleteItem(index: number): void {
  if (selectedLanguages.value && selectedLanguages.value.length > 0) {
    selectedLanguages.value.splice(index, 1);
  }
}
</script>
